module.exports = __webpack_public_path__ + "static/media/ipnos-proto-combined.6dfcdb35.png";